// SurveyIntro.jsx
import React from 'react';
import { Clock, Users, Shield, Mail, Phone } from 'lucide-react';
import './SurveyIntro.css';

const SurveyIntro = ({ onStart }) => {
  return (
    <div className="survey-intro">
      <div className="intro-header">
        <div className="bismillah">
          بسم الله الرحمن الرحيم
        </div>
      </div>

      <div className="intro-content">
        <div className="invitation-section">
          <h2 className="greeting-title">السادة / المشاركون الكرام</h2>
          <p className="greeting-text">السلام عليكم ورحمة الله وبركاته،،،</p>          <p className="invitation-text">
            يسرنا دعوتكم للمشاركة في هذه الاستبانة التي تحمل عنوان
            <span className="survey-title-highlight">
              "وجهة نظر القطاع الخاص السعودي بشأن أهمية الإفصاح عن البيانات الشخصية ومزاياه،
              وطبيعة هذه البيانات، في سياق التعيين أو التوظيف الفردي والمؤسسي"
            </span>
          </p>
        </div>

        <div className="objectives-section">
          <h3 className="section-title">أهداف الاستبانة</h3>
          <p className="objectives-text">
            تهدف هذه الاستبانة إلى التعرف عملياً على آراء وتوجهات القطاع الخاص في المملكة،
            واستكشاف المنظور السوقي الفعلي تجاه استخدام البيانات الشخصية في قرارات التعيين،
            سواء على المستوى الفردي أو المؤسسي، وذلك بالاعتماد على منهجية بحثية منظمة
            لضمان جودة النتائج وموثوقيتها.
          </p>
        </div>

        <div className="survey-info">
          <div className="info-cards">
            <div className="info-card">
              <Clock className="info-icon" />
              <div className="info-content">
                <h4>مدة الإنجاز</h4>
                <p>حوالي 10 دقائق</p>
              </div>
            </div>
            <div className="info-card">
              <Users className="info-icon" />
              <div className="info-content">
                <h4>عدد الأسئلة</h4>
                <p>34 سؤالاً</p>
              </div>
            </div>
          </div>
        </div>

        <div className="scope-section">
          <h3 className="section-title">مجالات التعيين المشمولة</h3>
          <div className="scope-types">
            <div className="scope-type">
              <div className="scope-number">1</div>
              <div className="scope-content">
                <h4>التعيين الفردي</h4>
                <p>مثل التوظيف، الترقية، الإشراف، عضوية فرق العمل واللجان، عضوية مجالس الإدارات، الإعارة، والعضويات التمثيلية.</p>
              </div>
            </div>
            <div className="scope-type">
              <div className="scope-number">2</div>
              <div className="scope-content">
                <h4>التعيين المؤسسي</h4>
                <p>مثل الشركاء من الملاك، المساهمين، المستثمرين، الموردين، الموزعين، المقاولين، والاستشاريين.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="privacy-section">
          <div className="privacy-card">
            <Shield className="privacy-icon" />
            <div className="privacy-content">
              <h3>ضمان السرية والخصوصية</h3>
              <p>
                نؤكد لكم أن جميع البيانات والمعلومات التي يتم تزويدنا بها ستُعامل بسرية تامة،
                ولن تُستخدم إلا لغرض تحليل التوجهات وتحقيق الفهم العملي لرؤية القطاع الخاص،
                بما يدعم تطوير السياسات والممارسات ذات الصلة.
              </p>
            </div>
          </div>
        </div>

        <div className="participation-value">
          <h3 className="section-title">قيمة مشاركتكم</h3>
          <p>
            مشاركتكم تمثل قيمة حقيقية في إثراء هذا الجهد، وتسهم في الوصول إلى تصور أكثر دقة
            لواقع السوق السعودي.
          </p>
        </div>

        <div className="contact-section">
          <h3 className="section-title">للاستفسار أو لمزيد من المعلومات</h3>
          <div className="contact-info-intro">
            {/* <div className="researcher-info" style={{color: 'black'}}>
              <h4 className="researcher-name-ar">أ.د. عبد الرحمن بن عبد العزيز حماد البواردي</h4>
              <h4 className="researcher-name-en">Prof. Abdulrahman Abdulaziz Albawardi</h4>
            </div> */}
            <div className="contact-details">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>البريد الإلكتروني: info@byaan.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyIntro;